import React, {Fragment, useEffect, useState} from "react";
 
import { useCookies } from "react-cookie";
import axios from "axios";
import ToggleSidebarItem from "./ToggleSidebarItem";
import SimpleSidebarItem from "./SimpleSidebarItem";
import * as Constants from "../../constants/urls";

const SidebarView = ({isOpen}) => {
       const [cookies, setCookie, removeCookie] = useCookies();
    const [data, setData] = useState(undefined);

    useEffect(()=>{
         const url =  Constants.panelApiUrl + "/api/v1/admin_menu/get";
         axios.get(url, {
            headers: {
                'Authorization': 'Bearer ' + cookies.user_server_token,
            }
        }).then((r) => {
           setData(r.data.result.data); 
        }).catch((e) => { 

        });
    },[]) 
    return (
        <aside
            id="sidebar-multi-level-sidebar"
            style={{zIndex:120 ,
                transform: isOpen ? "translateX(0)" : "translateX(100%)",
                backgroundColor:"#0f172b"
            }}
            className={`fixed top-14 right-0   w-48 h-screen transition-transform  ${isOpen ? "translate-x-0" : "translate-x-full"} `}
            aria-label="Sidebar"
        >
            <div className="h-full py-3 overflow-y-auto  ">
                <ul className=" font-medium divide-y divide-slate-100 mb-12">
                    {
                        data && data.map((item , index) => (<Fragment key={index}>
                            {
                                item.children &&  item.children.length>0 ? <ToggleSidebarItem menuItem={item}/> :
                                    <SimpleSidebarItem item={item} padding={false}/>
                            }
                        </Fragment>))
                    }
                </ul>
            </div>
        </aside>
    );
};

export default SidebarView;
